import { Typography } from '@mui/material';
import FieldNames from '../defaults/FieldNames.json';
import store from '../redux/store';
import { setAlertMessageObj } from '../redux/slices/globalContextSlice';

export function getAllFinalResults(allFinalResults, finalResults, isAll, costFieldName, acresFieldName) {
  const contributedLines = finalResults.filter(si => (si[FieldNames.featureFields.fundingSourceCategory] && 
    si[FieldNames.featureFields.fundingSourceCategory].includes(FieldNames.contributedCheck.contributed)));
  const bilLines = finalResults.filter(si => (si[FieldNames.featureFields.fundingSourceCategory] && 
    !si[FieldNames.featureFields.fundingSourceCategory].includes(FieldNames.contributedCheck.contributed) && 
    si[FieldNames.featureFields.fundingSourceCategory].includes(FieldNames.contributedCheck.bil)));
  const nonBilLines = finalResults.filter(si => (si[FieldNames.featureFields.fundingSourceCategory] && 
    !si[FieldNames.featureFields.fundingSourceCategory].includes(FieldNames.contributedCheck.contributed) && 
    !si[FieldNames.featureFields.fundingSourceCategory].includes(FieldNames.contributedCheck.bil)));
  const contributedCost = (contributedLines && contributedLines.length) ? contributedLines.map(x => x[costFieldName]) : [0];
  const totalCostBIL = (bilLines && bilLines.length) ? bilLines.map(x => x[costFieldName]) : [0];
  const totalCostNonBIL = (nonBilLines && nonBilLines.length) ? nonBilLines.map(x => x[costFieldName]) : [0];
  const totalCost = (finalResults && finalResults.length) ? finalResults.map(x => x[costFieldName]) : [0];
  const totalBILAcres = (bilLines && bilLines.length) ? bilLines.map(x => x[acresFieldName]) : [0];
  const totalBILNonAcres = (nonBilLines && nonBilLines.length) ? nonBilLines.map(x => x[acresFieldName]) : [0];
  const totalAcres = (finalResults && finalResults.length) ? finalResults.map(x => x[acresFieldName]) : [0];
  if(!isAll){
    allFinalResults.AllEstimatedTotalCostContributed = contributedCost;
    allFinalResults.AllEstimatedTotalCostBIL = totalCostBIL;
    allFinalResults.AllEstimatedTotalCostNonBIL = totalCostNonBIL;
    allFinalResults.AllEstimatedTotalCost = totalCost;
    allFinalResults.AllEstimatedBILAcres = totalBILAcres;
    allFinalResults.AllEstimatedNonBILAcres = totalBILNonAcres;
    allFinalResults.AllEstimatedTotalAcres = totalAcres;
  }
  return allFinalResults;
}

export function displayBulkApprovalFilterWarning (handleClose)
{
  store.dispatch(setAlertMessageObj({
    title: "Filter Error",
    severity: "error",
    child: (
      <Typography sx={{ marginLeft: "5px", marginRight: "5px" }}>
        You must have at least one funding org filter applied to access Bulk Approval.
      </Typography>
    ),
    callback: handleClose
  }));
}
